<template>
    <rkm-modal
        :title="impressao ? impressao.text : ''"
        extra-large
        persistent
        ref="RkmModal"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-button
                    @click="toogleAll"
                    color="primary"
                >
                    {{ isAllSelected ? 'Desmarcar' : 'Selecionar' }} todos
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-list
            :accordion="false"
            :items="solicitacoes"
            class="mt-2"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>
                    <rkm-col>
                        <strong>Data / Hora</strong><br />{{item.dataHora}}
                    </rkm-col>

                    <rkm-col>
                        <strong>Setor</strong><br />{{item.setorNome}}
                    </rkm-col>

                    <rkm-col>
                        <strong>Profissional</strong><br />{{item.usuarioNome}} - {{item.ocupacaoDescricao}}
                    </rkm-col>
                </rkm-row>

                <hr />

                <rkm-row>
                    <rkm-col cols="6">
                        <strong>CID 10</strong><br />{{item.cidDescricao ?? '-'}}
                    </rkm-col>

                    <rkm-col cols="6">
                        <strong>CIAP 2</strong><br />{{item.ciapDescricao ?? '-'}}
                    </rkm-col>

                    <rkm-col cols="12">
                        <strong>Justificativa do procedimento</strong><br />{{item.justificativa}}
                    </rkm-col>

                    <rkm-col cols="12">
                        <strong>Observações</strong><br />{{item.observacao}}
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:collapse="{item}">
                <div class="p-2">
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields"
                                :items="item.itens"
                                hide-filters
                                hide-pagination
                            >
                                <template v-slot:cell(check)="{ item }">
                                    <rkm-form-checkbox v-model="item.checked" />
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-list>

        <template v-slot:footer>
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="isAllUnselected"
                @click="confirm"
                color="primary"
            >
                Confirmar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    computed: {
        isAllSelected() {
            return this.solicitacoes.every(s => s.itens.every(i => i.checked))
        },
        isAllUnselected() {
            return this.solicitacoes.every(s => s.itens.every(i => !i.checked))
        }
    },
    data: () => ({
        fields: [
            {key: 'check', label: '#', class: 'col-min text-center'},
            {key: 'exameDescricao', label: 'Exame', sortable: true},
        ],
        impressao: null,
        solicitacoes: [],
    }),
    methods: {
        open(impressao) {
            this.impressao = impressao
            this.solicitacoes = this.clone(impressao.data)

            this.$refs.RkmModal.show()
        },
        toogleAll() {
            const check = !this.isAllSelected

            this.solicitacoes.forEach(s => s.itens.forEach(i => i.checked = check))
        },
        confirm() {
            this.impressao.data = this.solicitacoes
            this.close()
        },
        cancel() {
            this.close()
            this.$emit('cancel')
        },
        close() {
            this.$refs.RkmModal.hide()
        }
    },
    mixins: [object],
}
</script>